import React, {useState, useEffect} from "react";
import './PaginationHelper.scss'

export default function PaginationHelper(props){

  const [index, setIndex] = useState(0);
  const [list, setList] = useState(null);

  useEffect( () => {
    const context = props.context;
    if(typeof context !== 'object'){
      return;
    }

    const state = context.state;
    if(typeof state !== 'object'){
      return;
    }

    const naviService = state.navigationService;
    if(typeof naviService !== 'object'){
      return;
    }

    setIndex(naviService.customerInfoPagination.indexOf(state.webAppState));

    if(Array.isArray(naviService.customerInfoPagination)){
      setList(naviService.customerInfoPagination);
    }

  }, [props.context]);

  return (
    list ? (
      <div className="formContainer">
        <div className="pagination">
          {list.map( (value, idx) => {
            return <div key={`pagination-ele-${idx}`} className={`ui-circle ${index === idx ? `current` : ``}`}></div>;
          })}
        </div>
      </div>
    ) : <></>
  )
}